export default __webpack_public_path__ + "images/logoOrganicPharmacy.c8dabea3abe884039fb0cd586e0f8619.svg"